import ListBase from '@Component/form/ListBase';
import { backOfficeInvoiceListAllFetch } from '@Redux/slices/account/backOfficeInvoiceSlice';
import { history } from '../../../../redux/store';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PAYMENT_STATUS, CONTRACT_STATUS } from './BackOfficeConstant';
import Card from '@Utils/Card';

const defaultStyles = {
  fontSize: 11,
  fontWeight: '600',
  padding: '5px 10px',
  textTransform: 'uppercase',
  borderRadius: '50px',
};

const columns = [
  {
    title: 'Project Name',
    dataIndex: ['contract', 'product', 'name'],
    key: 'projectName',
    render: (text, record) => (
      <a
        onClick={() => {
          const contractId = record.contract?.id;

          let url = '/back-office/invoice-list';

          if (typeof contractId !== 'undefined' && contractId !== null) {
            url = url + `/${contractId}`;
          }

          history.push(url);
        }}
      >
        {text}
      </a>
    ),
  },
  {
    title: 'Contract Template',
    dataIndex: ['contract', 'contractTemplate', 'title'],
    key: 'contractTemplate',
    render: (text) => (text ? text : '-'),
  },
  {
    title: 'Contract Status',
    dataIndex: ['contract', 'status'],
    key: 'contractStatus',
    render: (text) =>
      text ? (
        <span
          className="Status"
          style={{
            ...defaultStyles,
            backgroundColor: CONTRACT_STATUS[text]?.bgColor || '#e7e8e9',
            color: CONTRACT_STATUS[text]?.color || '#94969e',
          }}
        >
          {text}
        </span>
      ) : (
        '-'
      ),
  },
  {
    title: 'Last Payment Status',
    dataIndex: 'status',
    key: 'lastPaymentStatus',
    render: (text) =>
      text ? (
        <span
          className="Status"
          style={{
            ...defaultStyles,
            backgroundColor: PAYMENT_STATUS[text]?.bgColor || '#e7e8e9',
            color: PAYMENT_STATUS[text]?.color || '#94969e',
          }}
        >
          {text}
        </span>
      ) : (
        '-'
      ),
  },
];

export const BackOfficeProjectTemplates = () => {
  const dispatch = useDispatch();

  const page = useSelector(
    (state) => state.account.backOffice.backOfficeInvoiceListAll
  );

  const pageRequest = useSelector(
    (state) => state.account.backOffice.pageRequest
  );
  const loading = useSelector((state) => state.account.backOffice.loading);

  useEffect(() => {
    dispatch(backOfficeInvoiceListAllFetch({ pageRequest }));
  }, []);

  return (
    <Card loading={loading} styles={{ margin: 24, display: 'flex', flex: 1 }}>
      <ListBase
        onChange={(p) =>
          dispatch(
            backOfficeInvoiceListAllFetch({
              ...pageRequest,
              page: p.page,
            })
          )
        }
        page={page}
        pageRequest={pageRequest}
        columns={columns}
        createLink={null}
      />
    </Card>
  );
};
